import { render, staticRenderFns } from "./SysReseller.vue?vue&type=template&id=c5d8d85c&scoped=true&"
import script from "./SysReseller.vue?vue&type=script&lang=js&"
export * from "./SysReseller.vue?vue&type=script&lang=js&"
import style0 from "./SysReseller.vue?vue&type=style&index=0&id=c5d8d85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d8d85c",
  null
  
)

component.options.__file = "SysReseller.vue"
export default component.exports